import { SvgIcon } from '@material-ui/core'

export default function PlusIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 25 25" fill="none" {...props}>
            <g opacity="0.75">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8279 13.2849H12.9999V16.1089C12.9999 16.5229 12.6639 16.8589 12.2499 16.8589C11.8359 16.8589 11.4999 16.5229 11.4999 16.1089V13.2849H8.67194C8.25794 13.2849 7.92194 12.9489 7.92194 12.5349C7.92194 12.1209 8.25794 11.7849 8.67194 11.7849H11.4999V8.96085C11.4999 8.54685 11.8359 8.21085 12.2499 8.21085C12.6639 8.21085 12.9999 8.54685 12.9999 8.96085V11.7849H15.8279C16.2419 11.7849 16.5779 12.1209 16.5779 12.5349C16.5779 12.9489 16.2419 13.2849 15.8279 13.2849ZM12.2499 2.29785C4.69094 2.29785 2.01294 4.97585 2.01294 12.5349C2.01294 20.0939 4.69094 22.7719 12.2499 22.7719C19.8079 22.7719 22.4869 20.0939 22.4869 12.5349C22.4869 4.97585 19.8079 2.29785 12.2499 2.29785Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    )
}
